"use client";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUser_ai_limit } from "@/store/mainSlice";

export default function UpgradePlan({ show, handleClose, userDetail }) {
  if (!show) return null;
  const dispatch = useDispatch();
  const [plan, setPlan] = useState(null);
  const [subPlan, setSubPlan] = useState(null);
  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState("idle");
  // const planId = process.env.NEXT_PUBLIC_APP_RAZORPAY_PLAN_ID

  useEffect(() => {
    const fetchSubPlan = async () => {
      try {
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_APP_CREATE_SUBSCRIPTION}`
        );

        const data = await response.json();
        console.log(data, "fetchSubPlan----data")
        setSubPlan(data || null);
      } catch (error) {
        console.error("Failed to fetch plan", error);
      }
    };

    fetchSubPlan();
  }, []);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        // const response = await fetch(process.env.NEXT_PUBLIC_APP_SUBSCRIPTION_STATUS);
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_APP_SUBSCRIPTION_STATUS}?userId=${userDetail._id}`
        );
        const data = await response.json();
        console.log(data, "----data")
        setSubscriptionStatus(data.status);
      } catch (error) {
        console.error("Failed to fetch plan", error);
      }
    };
    fetchStatus();
  }, []);

  const handleGetBusinessM = async () => {
    if (!plan?.id) return;
    try {
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_APP_CREATE_SUBSCRIPTION}/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            planId: subPlan._id,
            userId: userDetail._id
          }),
        }
      );

      const subscription = await res.json();
      console.log("Subscription created:", subscription);
      const options = {
        key: process.env.NEXT_PUBLIC_APP_RAZORPAY_KEY,
        subscription_id: subscription.subscription.id,
        name: "Varnz Agent Center",
        description: "Varnz Agent Center",
        handler: async function (response) {
          console.log("Payment Success", response);
          setSubscriptionStatus("success_popup");
          setShowPaymentPopup(true);
          dispatch(setUser_ai_limit(subscription.ai_limit)); 
        },
      };
      console.log(options, "Razorpay options");
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error("Subscription failed", err);
      setSubscriptionStatus("error");
    }
  };

  const handleGetBusiness = async () => {
    try {
      console.log(subPlan, "Selected Plan");
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_APP_CREATE_SUBSCRIPTION}/create-order`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            planId: subPlan._id,
            userId: userDetail._id
          }),
        }
      );

      const data = await res.json();
      const options = {
      key: process.env.NEXT_PUBLIC_APP_RAZORPAY_KEY,
      amount: data.amount,
      currency: "INR",
      order_id: data.orderId,
      name: data.plan.name,
      description: "Upgrade Plan",
      handler: async function (response) {
        const verifyRes = await fetch(
          `${process.env.NEXT_PUBLIC_APP_CREATE_SUBSCRIPTION}/verify-payment`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              ...response,
              planId: subPlan._id,
              userId: userDetail._id,
            }),
          }
        );
        const verifyData = await verifyRes.json();
        console.log("Payment Verification Result:", verifyData);
        if (verifyData.success) {
          dispatch(setUser_ai_limit(verifyData.ai_limit));
          setSubscriptionStatus("success_popup");
          setShowPaymentPopup(true);
        }
      },
    };
      console.log(options, "Razorpay options");
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error("Subscription failed", err);
      setSubscriptionStatus("error");
    }
  };

  return (
    <>
      {show && (

        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 backdrop-blur-[1px] bg-black/40 dark:bg-black/60 bg-opacity-60  ">
          <div className="relative w-full max-w-md rounded-2xl border p-6 shadow-xl bg-white text-gray-900 border-gray-200
    dark:bg-gradient-to-b dark:from-[#161616] dark:to-[#0e0e0e] dark:text-white dark:border-white/10">
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-black
    dark:text-gray-400 dark:hover:text-white transition"
              aria-label="Close"
            >
              ✕
            </button>

            {/* Header */}
            <div className="mb-6 text-center">
              <h2 className="text-2xl font-semibold">Varnz Agent Center</h2>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">Find, subscribe, and deploy specialized AI agents for your website, app, or internal use.</p>
            </div>

            {/* Price */}
            <div className="rounded-xl p-5 mb-6 bg-gray-50 border-gray-200
    dark:bg-white/5 dark:border-white/10">
              {/* <div className="flex items-center justify-between mb-2">
                <h3 className="text-lg font-medium">Starter Plan</h3>
              </div> */}


              <div className="flex items-end gap-2">
                {/* <span className="text-gray-400 dark:text-gray-500 line-through text-xl">₹200</span> */}
                <span className="text-4xl font-bold">₹200</span>
                {/* <span className="text-sm text-gray-500 dark:text-gray-400 mb-1">for first month</span> */}
              </div>
            </div>

            {/* CTA */}
            <button
              onClick={subscriptionStatus === "active" ? undefined : handleGetBusiness}
              disabled={subscriptionStatus === "active"}
              className={`w-full rounded-xl py-3 font-medium mb-6 transition
    ${subscriptionStatus === "active"
                  ? "bg-green-600 text-white cursor-not-allowed opacity-70"
                  : "bg-black text-white hover:bg-gray-800 dark:bg-white dark:text-black dark:hover:bg-gray-200"
                }
  `}
            >
              {subscriptionStatus === "active" ? "Current Plan" : "Upgrade Plan"}
            </button>


            {/* Features */}
            {subPlan && (
              <ul className="space-y-3 text-sm text-gray-700 dark:text-gray-300">
                {/* <li>✔ Up to {subPlan.totalProjects} projects</li> */}
                {/* <li>✔ {subPlan.filesPerProject} files per project</li> */}
                {/* <li>✔ {subPlan.maxGB} GB storage</li> */}
                <li>✔ Get {subPlan.monthlyCredits} Credits/month</li>
                <li>✔ Upload cost: {subPlan.uploadCostCredits} credits</li>
                <li>
                  ✔ Conversation cost: {subPlan.conversationCostPer50Words} credit / 50 words
                </li>
                {/* <li>✔ Monthly price: ₹{subPlan.monthlyPrice}</li> */}
              </ul>
            )}
          </div>
        </div>
      )}
      {showPaymentPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 dark:bg-black/60 bg-opacity-60">
          <div className=" w-full max-w-sm bg-white dark:bg-gradient-to-b dark:from-[#161616] dark:to-[#0e0e0e] dark:text-white dark:border-white/10 p-6 rounded-xl text-center">

            {subscriptionStatus === "error" ? (
              <>
                {/* Error Message */}
                <div className="flex flex-col items-center justify-center gap-4">
                  <div className="text-4xl">⚠️</div>
                  <h2 className="text-xl font-semibold">Verification Error</h2>
                  <p className="text-sm text-gray-500 dark:text-zinc-400 text-center">
                    There was an error verifying your subscription status.
                    Please refresh the page or contact support.
                  </p>
                  <button
                    onClick={() => {
                      window.location.reload();
                    }}
                    className="mt-4 w-full py-2 bg-black text-white rounded-lg dark:bg-white dark:text-neutral-900 font-medium py-3 dark:hover:bg-neutral-200 hover:bg-white hover:text-black transition-colors"
                  >
                    Refresh Page
                  </button>
                </div>
              </>
            ) :subscriptionStatus === "success_popup" && (
              <>
                {/* Success */}
                <div className="flex flex-col items-center justify-center gap-4 flex-1">
                  <h2 className="text-xl font-semibold">🎉 Congratulations</h2>
                  <p className="text-sm text-gray-500 dark:text-zinc-400 mt-2">
                   Your plan has been activated successfully
                  </p>
                      <button
                      onClick={() => {
                        // ✅ REAL ACTIVATION HERE
                        setSubscriptionStatus("active");
                        localStorage.setItem("subscriptionStatus", "active");

                        window.dispatchEvent(
                          new CustomEvent("subscription-updated", {
                            detail: { status: "active", userId: userDetail._id },
                          })
                        );
                        setShowPaymentPopup(false);
                        handleClose();
                        // window.location.reload();
                      }}
                        className="mt-4 w-full py-2 bg-black text-white rounded-lg dark:bg-white bg-black dark:text-neutral-900 text-white font-medium py-3 dark:hover:bg-neutral-200  hover:bg-white hover:text-black transition-colors"
                      >
                        Continue
                      </button>
                </div>
              </>
            )}

          </div>
        </div>
      )}
    </>
  )
}
